import PolicyLayout from "@/components/PolicyLayout";

export default function ShippingPolicyPage() {
  return (
    <PolicyLayout title="Shipping Policy">
      <p>
        We ship Pickle Wall™ orders from the United States. Exact carriers,
        processing times, and shipping rates are shown at checkout before you
        complete your order, and a confirmation with tracking information is
        sent by email once your order ships.
      </p>
      <p>
        Our complete shipping policy — including estimated delivery windows by
        region and details on international shipping — is currently being
        finalized and will be published here. If you need shipping details
        before ordering, contact us and we'll confirm timing for your location.
      </p>
    </PolicyLayout>
  );
}
